import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { config as configCore } from '@industriousapps/excelkits-core';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var DownloadIcon = function DownloadIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.3333 31.167C12.8981 31.167 14.1667 32.4355 14.1667 34.0003L14.1667 43.067C14.1667 45.494 14.1689 47.1438 14.2731 48.4191C14.3746 49.6612 14.5585 50.2965 14.7843 50.7396C15.3276 51.8059 16.1945 52.6727 17.2607 53.216C17.7039 53.4418 18.3391 53.6258 19.5813 53.7273C20.8565 53.8315 22.5064 53.8337 24.9333 53.8337L43.0667 53.8337C45.4936 53.8337 47.1435 53.8315 48.4187 53.7273C49.6609 53.6258 50.2961 53.4418 50.7393 53.216C51.8055 52.6728 52.6724 51.8059 53.2157 50.7396C53.4415 50.2965 53.6254 49.6612 53.7269 48.4191C53.8311 47.1438 53.8333 45.494 53.8333 43.067L53.8333 34.0003C53.8333 32.4355 55.1019 31.167 56.6667 31.167C58.2315 31.167 59.5 32.4355 59.5 34.0003L59.5 43.1841C59.5 45.4648 59.5001 47.3471 59.3748 48.8805C59.2447 50.4731 58.9654 51.9371 58.2647 53.3122C57.1782 55.4447 55.4444 57.1785 53.3119 58.2651C51.9368 58.9657 50.4728 59.245 48.8802 59.3751C47.3468 59.5004 45.4644 59.5004 43.1836 59.5003L24.8162 59.5003C22.5355 59.5004 20.6532 59.5004 19.1198 59.3751C17.5272 59.245 16.0632 58.9657 14.6881 58.2651C12.5556 57.1785 10.8218 55.4447 9.73526 53.3122C9.0346 51.9371 8.75534 50.4731 8.62521 48.8805C8.49993 47.3471 8.49996 45.4648 8.5 43.184L8.5 34.0003C8.5 32.4355 9.76853 31.167 11.3333 31.167Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M31.1667 11.3333C31.1667 9.76853 32.4352 8.5 34 8.5C35.5648 8.5 36.8334 9.76853 36.8334 11.3333L36.8334 35.6597L40.4966 31.9965C41.6031 30.89 43.397 30.89 44.5035 31.9965C45.61 33.103 45.61 34.897 44.5035 36.0035L36.0035 44.5035C34.897 45.61 33.1031 45.61 31.9966 44.5035L23.4966 36.0035C22.3901 34.897 22.3901 33.103 23.4966 31.9965C24.6031 30.89 26.397 30.89 27.5035 31.9965L31.1667 35.6597L31.1667 11.3333Z"
    })]
  }));
};

DownloadIcon.defaultProps = {
  width: "68",
  height: "68",
  viewBox: "0 0 68 68",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const SUPPORTED_FILE_TYPES = configCore.spreadsheets.supportedFileTypes;

const UploadFile = _ref => {
  let {
    onChange = () => undefined,
    onError = () => undefined,
    isDisabled = false,
    bgColor = '#fff',
    successColor = '#e3edff',
    errorColor = '#fff0f0',
    changeColorAfterDrop = true
  } = _ref;
  const {
    0: outerBackgroundColor,
    1: setOuterBackgroundColor
  } = useState('transparent'); // backgroundColor of outer box

  const {
    0: backgroundColor,
    1: setBackgroundColor
  } = useState(bgColor); // backgroundColor of upload-box
  // function that handles accepted file

  const handleFile = useCallback(file => {
    if (!file) return; // extract file extension from file

    const re = /(?:\.([^.]+))?$/; // @ts-ignore

    const ext = re.exec(file.name || '')[1]; // check whether file is supported or not

    if (SUPPORTED_FILE_TYPES.includes(ext)) {
      // supported
      if (changeColorAfterDrop) {
        setBackgroundColor(successColor);
        setOuterBackgroundColor(successColor);
      }

      return onChange(file);
    } else {
      // unsupported
      if (changeColorAfterDrop) {
        setBackgroundColor(errorColor);
        setOuterBackgroundColor(errorColor);
      }

      return onError(Error('Unsupported file'));
    }
  }, [successColor, errorColor, setBackgroundColor, changeColorAfterDrop, setOuterBackgroundColor, onChange, onError]); // EventListener which fires when drop or upload file

  const onDrop = useCallback(files => {
    if (isDisabled) return;

    if (files.length > 0) {
      handleFile(files[0]);
    }
  }, [isDisabled, handleFile]);
  const {
    getRootProps,
    getInputProps,
    isDragActive
  } = useDropzone({
    onDrop,
    noClick: true
  });
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, getRootProps({
    className: clsx(styles.container, isDisabled ? styles.disabled : ''),
    style: {
      backgroundColor: outerBackgroundColor
    }
  })), {}, {
    children: /*#__PURE__*/_jsxs("label", {
      htmlFor: "data-editor-add-data-file",
      className: clsx(styles.main, !isDisabled && isDragActive ? styles['main--active'] : ''),
      style: {
        backgroundColor
      },
      children: [/*#__PURE__*/_jsx(DownloadIcon, {}), isDisabled ? /*#__PURE__*/_jsx("h6", {
        className: clsx(styles.heading, styles['heading--loading']),
        children: "Processing File..."
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("p", {
          className: styles.heading,
          children: ["Drag and drop or\xA0", /*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({
            type: "file",
            id: "data-editor-add-data-file"
          }, getInputProps()), {}, {
            accept: SUPPORTED_FILE_TYPES.map(ft => `.${ft}`.trim()).join(', '),
            disabled: isDisabled
          })), /*#__PURE__*/_jsx("span", {
            className: styles.uploadLink,
            children: "choose file"
          }), "\xA0to upload"]
        }), /*#__PURE__*/_jsx("p", {
          className: styles['subHeading'],
          children: "XLSX files recommended."
        }), /*#__PURE__*/_jsxs("p", {
          className: styles.leading,
          children: ["Supports: ", SUPPORTED_FILE_TYPES.slice(1).join(', ')]
        })]
      })]
    })
  }));
};

export default UploadFile;